import React from "react";
import styles from "./IntroGame.module.css";
import Button from "../components/Button";
import brain from "../static/images/component_svg/brain.svg";

function IntroGame(props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        <div className={styles.header}>
          <img className={styles.img} src={brain} alt="brain"></img>
          <h1 className={styles.h1}>เกมทดสอบทักษะสมอง</h1>
        </div>
        <Button onClick={() => props.navigateNextPage()}>
          เริ่มต้นการทดสอบ
        </Button>
      </div>
    </div>
  );
}

export default IntroGame;
